var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-view"},[_c('div',{staticClass:"container-scroller"},[_c('Header'),_c('div',{staticClass:"container-fluid page-body-wrapper"},[_c('Sidebar'),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }